import { useRef, useState } from 'react';
import { categories } from '@/mocks/categories';

const trendingImages: Record<string, string> = {
  jackets: 'https://readdy.ai/api/search-image?query=Stylish%20olive%20green%20bomber%20jacket%20hanging%20on%20minimalist%20wooden%20hanger%20against%20warm%20concrete%20wall%2C%20soft%20directional%20lighting%2C%20modern%20editorial%20fashion%20photography%2C%20clean%20composition%2C%20premium%20catalog%20aesthetic&width=640&height=800&seq=trend-jackets-v2-2026&orientation=portrait',
  'pants-shorts': 'https://readdy.ai/api/search-image?query=Trendy%20beige%20cargo%20pants%20laid%20flat%20on%20textured%20linen%20surface%2C%20soft%20overhead%20natural%20lighting%2C%20minimalist%20product%20photography%2C%20warm%20earthy%20tones%2C%20clean%20modern%20aesthetic%2C%20professional%20ecommerce%20style&width=640&height=800&seq=trend-pants-v2-2026&orientation=portrait',
  headwear: 'https://readdy.ai/api/search-image?query=Elegant%20straw%20hat%20and%20minimalist%20cap%20displayed%20on%20wooden%20shelf%20with%20warm%20sunlight%2C%20boutique%20store%20aesthetic%2C%20soft%20shadows%2C%20cream%20and%20sand%20color%20palette%2C%20lifestyle%20product%20photography%2C%20refined%20composition&width=640&height=800&seq=trend-headwear-v2-2026&orientation=portrait',
  sets: 'https://readdy.ai/api/search-image?query=Coordinated%20matching%20loungewear%20set%20in%20soft%20sage%20green%20displayed%20on%20wooden%20surface%2C%20natural%20morning%20light%2C%20minimalist%20aesthetic%2C%20premium%20fabric%20texture%20visible%2C%20clean%20editorial%20style%2C%20warm%20neutral%20background&width=640&height=800&seq=trend-sets-v2-2026&orientation=portrait',
};

export default function TrendingCategories() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);
  const trendingCats = categories.slice(3, 7);

  const checkScroll = () => {
    const el = scrollRef.current;
    if (!el) return;
    setCanScrollLeft(el.scrollLeft > 10);
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - 10);
  };

  const scroll = (direction: 'left' | 'right') => {
    const el = scrollRef.current;
    if (!el) return;
    const amount = 340;
    el.scrollBy({ left: direction === 'left' ? -amount : amount, behavior: 'smooth' });
    setTimeout(checkScroll, 400);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex items-end justify-between mb-12">
          <div>
            <h2 className="text-3xl md:text-4xl text-foreground-900"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              Trending Categories
            </h2>
            <p className="text-foreground-500 text-sm mt-2">All 14 categories at a glance</p>
          </div>
          <div className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              disabled={!canScrollLeft}
              className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:text-foreground-800 hover:border-foreground-400 transition-colors cursor-pointer disabled:opacity-30 disabled:cursor-default"
              aria-label="Scroll left"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              disabled={!canScrollRight}
              className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer disabled:opacity-30 disabled:cursor-default"
              aria-label="Scroll right"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          onScroll={checkScroll}
          className="flex gap-5 overflow-x-auto pb-4"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {trendingCats.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex-shrink-0 w-[280px] md:w-[320px] rounded-2xl overflow-hidden cursor-pointer relative transition-transform duration-300 hover:-translate-y-1"
              style={{ boxShadow: '0 2px 16px rgba(0,0,0,0.04)' }}
            >
              <div className="aspect-[4/5] relative overflow-hidden">
                <img
                  src={trendingImages[cat.slug]}
                  alt={`${cat.name} - AllChinaBuySpreadsheet`}
                  title={`${cat.name} Products`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                {cat.tag && (
                  <span className="absolute top-3 right-3 px-2.5 py-1 rounded-full text-[11px] font-semibold bg-accent-500 text-background-50 whitespace-nowrap">
                    {cat.tag}
                  </span>
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <p className="text-white text-lg font-semibold">{cat.name}</p>
                <p className="text-white/60 text-xs mt-1">{cat.description}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}